import {hel_CallSceneComponent} from '../../logics/lib';

import {CItemPropertyApiNotification} from './CItemPropertyApiNotification';

import type {JsonObject} from '../../../../HeliportJS/dist/models/json';
import type {hel_DispatchEvent} from '../../logics/moduleCaller';

/**
 * @remarks
 * TODO: 本クラスでは、互換性維持のために {@link hel_CallSceneComponent} を使用しているが、本クラスの転用は禁止。代わりに {@link hel_DispatchEvent} を利用する。
 */
export class CItemProperty {
  m_ItemPropertyApiNotification: CItemPropertyApiNotification | null = null;

  // コンストラクタ
  constructor() {
    this.m_ItemPropertyApiNotification = new CItemPropertyApiNotification();
  }

  /** ItemPropertyアクティビティの同期処理を起動 */
  addReceivedPropertyChangeEventListener(fn: (params: JsonObject) => void) {
    this.m_ItemPropertyApiNotification?.addPosChannelEvent(fn);
  }

  /** 個別ItemPropertyアクティビティの同期処理を起動 */
  addReceivedPersonalPropertyChangeEventListener(fn: (params: JsonObject) => void) {
    this.m_ItemPropertyApiNotification?.addPersonalEvent(fn);
  }

  addReceivedWorldPropertyChangeEventListener(fn: (params: JsonObject) => void) {
    this.m_ItemPropertyApiNotification?.addWorldEvent(fn);
  }

  /**
   * ItemPropertyアクティビティの同期処理を起動
   * @param params Jsonオブジェクト
   */
  receive(params: any) {
    hel_CallSceneComponent(
      params.ReferenceID,
      'ActivitySyncInterface',
      'SetPropertyViaSync',
      JSON.stringify(params)
    );
  }

  /**
   * 個別ItemPropertyアクティビティの同期処理を起動
   * @param params Jsonオブジェクト
   */
  receivePersonal(params: any) {
    hel_CallSceneComponent(
      params.ReferenceID,
      'ActivitySyncInterface',
      'SetPropertyViaSync',
      JSON.stringify(params)
    );
  }

  /**
   * @param params Jsonオブジェクト
   */
  receiveWorld(params: any) {
    hel_CallSceneComponent(
      params.ReferenceID,
      'ActivitySyncInterface',
      'SetPropertyViaSync',
      JSON.stringify(params)
    );
  }
}
